import { render, staticRenderFns } from "./SamSimpleModal.vue?vue&type=template&id=4255a243&scoped=true&"
import script from "./SamSimpleModal.vue?vue&type=script&lang=js&"
export * from "./SamSimpleModal.vue?vue&type=script&lang=js&"
import style0 from "./SamSimpleModal.vue?vue&type=style&index=0&id=4255a243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4255a243",
  null
  
)

export default component.exports